export default function ExternalLinkIcon({
  width = 22,
  height = 22,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.001 11 11 19.997 19.997 11l-8.998-8.998L2.001 11ZM.937 12.057a1.495 1.495 0 0 1 0-2.115L9.942.938a1.495 1.495 0 0 1 2.114 0l9.005 9.004c.584.584.584 1.531 0 2.115l-9.005 9.004a1.495 1.495 0 0 1-2.114 0L.937 12.057Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.78 7.094a.75.75 0 1 0-1.06 1.061l.97.97H11a5.25 5.25 0 0 0-4.555 2.64.75.75 0 1 0 1.301.745A3.748 3.748 0 0 1 11 10.625h1.69l-.97.97a.75.75 0 0 0 1.06 1.06l2.245-2.244a.755.755 0 0 0 .225-.536.747.747 0 0 0-.225-.536L12.78 7.094Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
